import { compose, withProps } from 'recompose';
import { get } from 'lodash';

import { isEditMode } from '../../helpers/isEditMode';
import withAllLocationsTab from './withAllLocationsTab';

const withProfileHoc = compose(
  withProps((props) => ({
    barberId: get(props, 'params.barberId'),
    isBrandViewActive: true,
    edit: isEditMode(props),
  })),
  withAllLocationsTab
);

export default withProfileHoc;
